import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { SearchServiceaftalerResponseDto } from 'src/app/api/models/OK/EGIS/Service/Ekstern/Models/DTO/search-serviceaftaler-response-dto';
import { ServiceaftaleDto } from 'src/app/api/models/OK/EGIS/Service/Ekstern/Models/DTO/serviceaftale-dto';
import { EgisService } from 'src/app/api/services';
import { ErrorhandlerService } from 'src/app/services/errorhandler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ServiceordreDto } from '../../api/models/OK/EGIS/Service/Ekstern/Models/DTO/serviceordre-dto';
import { MatDialog } from '@angular/material/dialog';
import {
  CancelServiceordreComponent,
  CancelServiceordreData,
  CancelServiceordreResult,
} from '../cancel-serviceordre/cancel-serviceordre.component';
import { PartnerDialogComponent } from '../shared/partner-dialog/partner-dialog.component';
import { PartnerInfoDto } from 'src/app/api/models/OK/EGIS/Service/Ekstern/Models/DTO/partner-info-dto';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup;

  response: SearchServiceaftalerResponseDto | null = null;
  serviceaftaler: ServiceaftaleDto[] = [];

  get searchQuery() {
    return this.form.get('searchQuery');
  }

  unsubscribe$ = new Subject<void>();

  constructor(
    private fb: UntypedFormBuilder,
    private egis: EgisService,
    public loader: LoaderService,
    private errorHandler: ErrorhandlerService,
    private dialog: MatDialog
  ) {
    this.form = this.fb.group({
      searchQuery: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  expandedElement: ServiceaftaleDto | null = null;

  displayedColumns: string[] = [
    'status',
    'aftaleNummer',
    'kundeNavn',
    'kundeAdresse',
    'partner',
    'serviceabonnement',
    'rowAction',
  ];

  serviceordreColumns: string[] = [
    'deadline',
    'ordrenr',
    'type',
    'status',
    'partner',
    'changed',
    'created',
  ];

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  resetSearchQuery() {}

  search(): void {
    this.response = null;
    this.serviceaftaler = [];
    this.expandedElement = null;
    this.loader.show();
    this.egis
      .searchServiceaftaler({
        caller: 'OK.EGIS.Portal.Ekstern',
        body: {
          searchQuery: this.searchQuery?.value,
        },
      })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.loader.hide();
        })
      )
      .subscribe(
        (response: SearchServiceaftalerResponseDto) => {
          this.response = response;
          if (response.serviceaftaler) {
            this.serviceaftaler = response.serviceaftaler;
          }
        },
        (err) => {
          this.errorHandler.handleError(err);
        }
      );
  }

  cancel(serviceordreNo: number, serviceaftale: ServiceaftaleDto) {
    const data: CancelServiceordreData = { serviceordreNo: serviceordreNo };
    let dialogRef = this.dialog.open(CancelServiceordreComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result: CancelServiceordreResult) => {
      if (result.confirm) {
        this.loader.show();

        this.egis
          .cancelServiceordre({
            caller: 'OK.EGIS.Portal.Ekstern',
            serviceordreNo: serviceordreNo,
            note: result.note,
          })
          .pipe(
            takeUntil(this.unsubscribe$),
            finalize(() => {
              this.loader.hide();
            })
          )
          .subscribe(
            () => {
              const serviceordre = serviceaftale.serviceordrer?.find(
                (x: ServiceordreDto) => x.serviceordreNo == serviceordreNo
              );
              if (serviceordre) {
                serviceordre.serviceordreStateText = 'Annulering fremsendt';
              }
            },
            (err) => {
              this.errorHandler.handleError(err);
            }
          );
      }
    });
  }

  openPartnerInfo(partnerInfo: PartnerInfoDto) {
    this.dialog.open(PartnerDialogComponent, {
      data: partnerInfo,
    });
  }

  hentSeneste() {
    this.response = null;
    this.serviceaftaler = [];
    this.expandedElement = null;
    this.loader.show();
    this.egis
      .serviceaftaleHistory({ caller: 'OK.EGIS.Portal.Ekstern' })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.loader.hide();
        })
      )
      .subscribe({
        next: (response) => {
          this.response = response;
          if (response.serviceaftaler) {
            this.serviceaftaler = response.serviceaftaler;
          }
        },
        error: (e) => this.errorHandler.handleError(e),
      });
  }
}
